import { TextoComponentInterface } from '../../../_config/interfaces/interface';
import TextoComponent from '../textoComponent/TextoComponent';
import styles from './Texto.module.css';

export default function Texto(props: TextoComponentInterface) {
    return (
        <TextoComponent {...props} className={`${styles.texto} ${props.className}`} />
    )
}
